/**
 * Каталог моделей на всё приложение.
 *
 * Список нужен и боковому меню (раскрывающийся список моделей), и странице
 * каталога — грузим его один раз здесь, чтобы не дублировать запрос.
 */
import { createContext, useContext, useMemo, type ReactNode } from "react";
import { api } from "../api/client";
import { useAsync } from "../api/hooks";
import type { CatalogResponse } from "../api/types";

interface CatalogApi {
  catalog: CatalogResponse | null;
  loading: boolean;
  error: Error | null;
  reload: () => void;
}

const CatalogContext = createContext<CatalogApi | null>(null);

export function CatalogProvider({ children }: { children: ReactNode }) {
  const { data, loading, error, reload } = useAsync(() => api.catalog(), []);
  const value = useMemo(
    () => ({ catalog: data, loading, error, reload }),
    [data, loading, error, reload],
  );
  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
}

export function useCatalog(): CatalogApi {
  const context = useContext(CatalogContext);
  if (!context) throw new Error("useCatalog must be used inside <CatalogProvider>");
  return context;
}
